export default __webpack_public_path__ + "img/2b9c139be7a9dcb19ca0af0251afd007.svg";